export const clpLabelDropDownLearnMoreButtonText = "ZFb";
export const clpLabelDropDownLearnMoreButtonToolTipText = "_Fb";
export const clpLabelCannotChangeLabelModalTitle = "$Fb";
export const clpLabelCannotChangeLabelModalSubtext = "aGb";
export const clpLabelCannotChangeLabelWithCloudAttachment = "bGb";
export default {clpLabelDropDownLearnMoreButtonText,clpLabelDropDownLearnMoreButtonToolTipText,clpLabelCannotChangeLabelModalTitle,clpLabelCannotChangeLabelModalSubtext,clpLabelCannotChangeLabelWithCloudAttachment};